"use client";

import Image from "next/image";
import Link from "next/link";

type Props = {
  theme?: "dark" | "light";
  height?: number;
};

export default function RewardsV2Logo({ theme = "dark", height = 36 }: Props) {
  const src =
    theme === "light"
      ? "/rewards-v2/popcard-logo-light.svg"
      : "/rewards-v2/popcard-logo-dark.svg";
  return (
    <Image
      src={src}
      alt="Popcard Rewards"
      width={140}
      height={height}
      style={{ height, width: "auto" }}
      priority
    />
  );
}
